import { useEffect, useState } from "react";
import { isNumeric } from "~/utils/utils";

const initialState = {
  currentPage: 1,
  itemsPerPage: 0,
  totalItems: 0,
  cursor: null,
  boundaryCursor: null,
};

const usePagination = (responseHeaders = {}) => {
  const [pagination, setPagination] = useState(initialState);

  useEffect(() => {
    if (Object.prototype.hasOwnProperty.call(responseHeaders, "x-angie-paginationcurrentpage")) {
      setPagination((prevState) => ({
        ...prevState,
        currentPage: parseInt(responseHeaders[`x-angie-paginationcurrentpage`]),
      }));
    }

    if (Object.prototype.hasOwnProperty.call(responseHeaders, `x-angie-paginationitemsperpage`)) {
      setPagination((prevState) => ({
        ...prevState,
        itemsPerPage: parseInt(responseHeaders[`x-angie-paginationitemsperpage`]),
      }));
    }

    if (Object.prototype.hasOwnProperty.call(responseHeaders, `x-angie-paginationtotalitems`)) {
      setPagination((prevState) => ({
        ...prevState,
        totalItems: parseInt(responseHeaders[`x-angie-paginationtotalitems`]),
      }));
    }

    if (Object.prototype.hasOwnProperty.call(responseHeaders, `x-angie-paginationnextcursor`) || pagination.cursor) {
      let cursor = responseHeaders[`x-angie-paginationnextcursor`];

      cursor = !cursor || cursor.length === 0 ? null : isNumeric(cursor) ? parseInt(cursor) : cursor;

      setPagination((prevState) => ({ ...prevState, cursor }));
    }

    if (
      Object.prototype.hasOwnProperty.call(responseHeaders, `x-angie-paginationboundarycursor`) ||
      pagination.boundaryCursor
    ) {
      let boundaryCursor = responseHeaders[`x-angie-paginationboundarycursor`];

      boundaryCursor =
        !boundaryCursor || boundaryCursor.length === 0
          ? null
          : isNumeric(boundaryCursor)
          ? parseInt(boundaryCursor)
          : boundaryCursor;

      setPagination((prevState) => ({ ...prevState, boundaryCursor }));
    }
  }, [pagination.cursor, pagination.boundaryCursor, responseHeaders]);

  return pagination;
};

export default usePagination;
